<h3 class="ui-headline">{{ '2fa.password_verification.p' | translate }}</h3>
<form [formGroup]="passwordForm" #passwordFormDirective="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-row" [class.invalid]="passwordFormDirective?.submitted && passwordControl?.invalid">
    <label class="form-label">{{ '2fa.password_verification.pass' | translate }}</label>
    <input
      appAutoFocus
      class="form-input password"
      formControlName="password"
      [type]="visible ? 'text' : 'password'"
      [placeholder]="'2fa.password_verification.currentPass' | translate"
    />
    <span
      (click)="visible = !visible"
      class="form-input-with-icon"
      [ngClass]="!visible ? 'icon-i-visibility-off' : 'icon-i-visibility-on'"
    ></span>
  </div>
  <!--./form-row-->
  <div class="ui-button-group">
    <button type="submit" class="ui-button" [class.loading]="validatePasswordLoading">
      <span class="icon-i-windmill"></span>
      {{ 'kids.verification_screen.cta' | translate }}
    </button>
    <button (click)="onCancel()" class="ui-button-text">
      <span>{{ 'modals.consultation.cta.cancel' | translate }}</span>
    </button>
  </div>
</form>
